import React from 'react';
import './App.css';
import DeckVisualizer from './components/DeckVisualizer';

function App() {
  return (
    <div className="App">
      <DeckVisualizer />
    </div>
  );
}

export default App;
